import { defineClientModule } from '../client-module';

/**
 * AI Voice Agents. Backed by the existing Worker route
 * GET /api/voice/agents, which scopes to the authenticated actor's tenants and
 * returns the provider-neutral, server-redacted Voice contract.
 */
export const agentsModule = defineClientModule({
  id: 'agents',
  recordTypeKey: 'agent',
  label: 'AI Voice Agents',
  route: '/ai-systems/agents',
  navGroup: 'AI Systems',
  icon: 'Bot',
  description: 'The AI agents answering and making calls for your business.',
  source: { endpoint: '/api/voice/agents', tableKey: 'agents' },
  search: { placeholder: 'Name, role, phone, or status' },
  filters: [
    {
      id: 'status',
      label: 'Status',
      options: ['All', 'active', 'mapped', 'draft', 'disabled', 'error'],
    },
  ],
  card: {
    title: 'Agent Name',
    subtitle: 'Agent Role',
    image: 'Agent Avatar',
    badges: ['Setup Status', 'Visibility'],
    facts: [
      { source: 'Setup Detail', label: 'Status' },
      { source: 'Agent Type', label: 'Type' },
      { source: 'Agent Phone Number', label: 'Phone' },
      { source: 'recentCallCount', label: 'Recent calls' },
    ],
  },
  detail: {
    title: 'Agent Name',
    subtitle: 'Agent Role',
    image: 'Agent Avatar',
    badges: ['Setup Status', 'Visibility'],
    sections: [
      {
        id: 'status',
        title: 'Current status',
        fields: [
          { source: 'Setup Status', label: 'Status' },
          { source: 'Setup Detail', label: 'Details' },
          { source: 'recentCallCount', label: 'Recent calls' },
          { source: 'followUpCount', label: 'Follow-ups' },
          { source: 'lastCallAt', label: 'Last call', format: 'datetime' },
        ],
      },
      {
        id: 'profile',
        title: 'Profile',
        fields: [
          { source: 'Agent Type', label: 'Type' },
          { source: 'Agent Role', label: 'Role' },
          { source: 'Agent Phone Number', label: 'Phone' },
          { source: 'Last Modified', label: 'Last Updated', format: 'datetime' },
        ],
      },
    ],
  },
  clientSafeFields: [
    'Agent Avatar',
    'Agent Name',
    'Agent Profile Status',
    'Setup Status',
    'Setup Detail',
    'Agent Type',
    'Company Name (from Assigned Client)',
    'Visibility',
    'Connection Status',
    'Agent Role',
    'Voice Type',
    'Agent Phone Number',
    'recentCallCount',
    'followUpCount',
    'lastCallAt',
    'Last Modified',
  ],
  emptyState: {
    title: 'No agents to show.',
    body: 'Try clearing your search and filters. If you expected an agent here, message the One Up team.',
  },
  actions: [
    { id: 'refresh', label: 'Refresh' },
  ],
});
